import React from 'react'

const coursemenuAPI = {
    defaultActiveKey:"mostpopular",
    tabname:[
        {
            tbname:"Most Popular",
            tabkey:"mostpopular",
            data:[
                {
                    img:"/assets/images/Common/megamenu/mostpopular/card1.png",
                    title:"Course Title",
                    paragraph:"Lorem ipsum dolor sit amet consectetur. Neque mauris"
                },
                {
                    img:"/assets/images/Common/megamenu/mostpopular/card2.png",
                    title:"Course Title",
                    paragraph:"Lorem ipsum dolor sit amet consectetur. Neque mauris"
                },
                {
                    img:"/assets/images/Common/megamenu/mostpopular/card3.png",
                    title:"Course Title",
                    paragraph:"Lorem ipsum dolor sit amet consectetur. Neque mauris"
                },
                {
                    img:"/assets/images/Common/megamenu/mostpopular/card4.png",
                    title:"Course Title",
                    paragraph:"Lorem ipsum dolor sit amet consectetur. Neque mauris"
                },
                {
                    img:"/assets/images/Common/megamenu/mostpopular/card5.png",
                    title:"Course Title",
                    paragraph:"Lorem ipsum dolor sit amet consectetur. Neque mauris"
                },
                {
                    img:"/assets/images/Common/megamenu/mostpopular/card6.png",
                    title:"Course Title",
                    paragraph:"Lorem ipsum dolor sit amet consectetur. Neque mauris"
                },
            ]
        },
        {
            tbname:"Top Seller",
            tabkey:"topseller",
            data:[
                {
                    img:"/assets/images/Common/megamenu/mostpopular/card1.png",
                    title:"Course Title 1",
                    paragraph:"Lorem ipsum dolor sit amet consectetur. Neque mauris"
                },
                {
                    img:"/assets/images/Common/megamenu/mostpopular/card2.png",
                    title:"Course Title",
                    paragraph:"Lorem ipsum dolor sit amet consectetur. Neque mauris"
                },
                {
                    img:"/assets/images/Common/megamenu/mostpopular/card3.png",
                    title:"Course Title",
                    paragraph:"Lorem ipsum dolor sit amet consectetur. Neque mauris"
                },
            ]
        },
        {
            tbname:"Top Rated",
            tabkey:"topratex",
            data:[
                {
                    img:"/assets/images/Common/megamenu/mostpopular/card1.png",
                    title:"Course Title 2",
                    paragraph:"Lorem ipsum dolor sit amet consectetur. Neque mauris"
                },
                {
                    img:"/assets/images/Common/megamenu/mostpopular/card2.png",
                    title:"Course Title",
                    paragraph:"Lorem ipsum dolor sit amet consectetur. Neque mauris"
                },
                {
                    img:"/assets/images/Common/megamenu/mostpopular/card3.png",
                    title:"Course Title",
                    paragraph:"Lorem ipsum dolor sit amet consectetur. Neque mauris"
                },
            ]
        },
    ],

}
const blogmenuAPI = {
    defaultActiveKey:"mostpopular",
    tabname:[
        {
            tbname:"Most Popular",
            tabkey:"mostpopular",
            data:[
                {
                    img:"/assets/images/Common/megamenu/mostpopular/card1.png",
                    title:"Blog Title",
                    paragraph:"Lorem ipsum dolor sit amet consectetur. Neque mauris"
                },
                {
                    img:"/assets/images/Common/megamenu/mostpopular/card2.png",
                    title:"Blog Title",
                    paragraph:"Lorem ipsum dolor sit amet consectetur. Neque mauris"
                },
                {
                    img:"/assets/images/Common/megamenu/mostpopular/card3.png",
                    title:"Blog Title",
                    paragraph:"Lorem ipsum dolor sit amet consectetur. Neque mauris"
                },
                {
                    img:"/assets/images/Common/megamenu/mostpopular/card4.png",
                    title:"Blog Title",
                    paragraph:"Lorem ipsum dolor sit amet consectetur. Neque mauris"
                },
                {
                    img:"/assets/images/Common/megamenu/mostpopular/card5.png",
                    title:"Blog Title",
                    paragraph:"Lorem ipsum dolor sit amet consectetur. Neque mauris"
                },
                {
                    img:"/assets/images/Common/megamenu/mostpopular/card6.png",
                    title:"Blog Title",
                    paragraph:"Lorem ipsum dolor sit amet consectetur. Neque mauris"
                },
            ]
        },
        {
            tbname:"Top Seller",
            tabkey:"topseller",
            data:[
                {
                    img:"/assets/images/Common/megamenu/mostpopular/card1.png",
                    title:"Blog Title 1",
                    paragraph:"Lorem ipsum dolor sit amet consectetur. Neque mauris"
                },
                {
                    img:"/assets/images/Common/megamenu/mostpopular/card2.png",
                    title:"Blog Title",
                    paragraph:"Lorem ipsum dolor sit amet consectetur. Neque mauris"
                },
                {
                    img:"/assets/images/Common/megamenu/mostpopular/card3.png",
                    title:"Blog Title",
                    paragraph:"Lorem ipsum dolor sit amet consectetur. Neque mauris"
                },
            ]
        },
        {
            tbname:"Top Rated",
            tabkey:"topratex",
            data:[
                {
                    img:"/assets/images/Common/megamenu/mostpopular/card1.png",
                    title:"Blog Title 2",
                    paragraph:"Lorem ipsum dolor sit amet consectetur. Neque mauris"
                },
                {
                    img:"/assets/images/Common/megamenu/mostpopular/card2.png",
                    title:"Blog Title",
                    paragraph:"Lorem ipsum dolor sit amet consectetur. Neque mauris"
                },
                {
                    img:"/assets/images/Common/megamenu/mostpopular/card3.png",
                    title:"Blog Title",
                    paragraph:"Lorem ipsum dolor sit amet consectetur. Neque mauris"
                },
            ]
        },
    ],

}



const NavDropDownAPI = () => {
  return (
    <>

    </>
  )
}


export {coursemenuAPI,blogmenuAPI}

export default NavDropDownAPI